"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Empty = Empty;
exports.Layout = Layout;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _EmptyList = _interopRequireDefault(require("../Settings/components/EmptyList"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function Layout(_ref) {
  var children = _ref.children,
    loading = _ref.loading;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var title = (0, _react.useMemo)(function () {
    return loading ? null : /*#__PURE__*/_react["default"].createElement("h1", {
      className: "mb-3 text-xl font-semibold text-dark"
    }, t('contactDetail.messages.title'));
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow flex flex-col"
  }, title, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-grow"
  }, children));
}
function Empty() {
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement(_EmptyList["default"], {
    image: t('empty-settings-contacts.png'),
    title: t('settings.contacts.empty.title'),
    subtitle: t('settings.contacts.empty.subtitle')
  });
}
//# sourceMappingURL=Messages.js.map